import { render, staticRenderFns } from "./GameVersion-edit.vue?vue&type=template&id=0c686494&"
import script from "./GameVersion-edit.vue?vue&type=script&lang=js&"
export * from "./GameVersion-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports